module.exports = __webpack_public_path__ + "media/images/map_icons/Skiing-881742427c7548208a5aeee5cf4449ca.svg";